import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const audienceSquare11Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'msan_1x1',
  className: 'msan_1x1',
  aspectRatio: 1,
  type: 'Image1x1',
  associationType: 'SquareImageMedia',
  imagePreviewHeight: 75,
  minimumRequirements: 0,
  minSize: [300, 300],
  localizedText: {
    previewTypeStringKey: _TL_('MSN square image'),
    stringKey: _TL_('1:1'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showShortHeadlineMultiline: true,
    showAdditionalDisclaimer: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    businessNameWithAds: {
      padding: '1px 0',
      marginTop: 9,
      '& .adslabel': {
        border: '.5px solid #78718a',
        color: '#78718a',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '13.64px',
        textDecorationThickness: 'auto',
        textSizeAdjust: '100%',
        borderRadius: '4px',
        background: '#fff',
        padding: '.8px 4px',
        margin: '0 5px 0 0',
      },
      '& .business-name': {
        color: '#333',
        fontSize: 11,
        lineHeight: '15.004px',
        padding: '1px 0',
      },
    },
    previewContent: {
      border: '0.5px solid #ddd',
      width: 300,
      height: 90,
      padding: 0,
    },
    imageContainer: {
      float: 'left',
      transform: 'none',
      width: 80,
      height: 75,
      margin: '8px',
    },
    textContainer: {
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
    },
    shortHeadline: {
      fontWeight: 600,
      fontSize: 13,
      lineHeight: 1.384,
      height: 45,
      overflow: 'hidden',
      margin: '8px 8px 0 8px',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
    },
    description: {
      color: '#333',
      fontSize: '13px',
    },
  },
};

export default audienceSquare11Raw;
